import {createAction, createReducer} from '@reduxjs/toolkit';

export const initialState = false;

export const toggleCaliforniaPrepositionPopup = createAction(
    'CHECKOUT@TOGGLE_CALIFORNIA_PREPOSTION_POPUP',
);

/**
 * Show California Preposition popup state
 * @return {boolean} State
 */
export const showCaliforniaPrepositionPopup = createReducer(initialState, builder => {
    builder.addCase(toggleCaliforniaPrepositionPopup, state => !state);
});
